import { axios as api } from '@/plugins/axios';

export class CompanyService {
  endpoint: string;
  constructor() {
    this.endpoint = 'v1/companies/';
  }
  async fetchCompanies() {
    return api.get(`${this.endpoint}`).then(({ data }) => data);
  }
  async fetchCompany(id: number) {
    return api.get(`${this.endpoint}${id}`).then(({ data }) => data);
  }
  async createCompany(payload: object) {
    return api.post(`${this.endpoint}`, payload).then(({ data }) => data);
  }
  async updateCompany(id: number, payload: object) {
    return api.patch(`${this.endpoint}${id}`, payload).then(({ data }) => data);
  }
  async deleteCompany(id: number) {
    return api.delete(`${this.endpoint}${id}`);
  }
}
